import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { trustedCreators, stats } from "../mockData";
import { useLocation } from "react-router-dom";
import "../styles/fonts.css";
import { useNavigate } from "react-router-dom";


const HeroSection = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const transitionProps = {
    duration: 0.65,
    ease: [0.22, 1, 0.36, 1],
  };

  useEffect(() => {
    if (location.state?.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 300);
      }
    }
  }, [location]);

  return (
    <section className="w-full pt-24 md:pt-28 pb-0 relative overflow-hidden bg-transparent">
      <div className="mx-auto max-w-[1100px] md:scale-[0.87] origin-top">
        <div className="max-w-[1100px] mx-auto px-4 sm:px-6 relative z-10 font-inter">

          {/* ================= TRUSTED BADGE ================= */}
          <motion.div
            className="flex justify-center md:justify-start mb-8 md:mb-10"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ ...transitionProps, delay: 0.1 }}
          >
            <div className="flex items-center gap-3 bg-white rounded-full px-4 py-2 shadow-sm">
              <div className="flex -space-x-2">
                {trustedCreators.map((c, i) => (
                  <img
                    key={i}
                    src={c.image}
                    alt="creator"
                    className="w-6 h-6 md:w-7 md:h-7 rounded-full border-2 border-white object-cover"
                  />
                ))}
              </div>
              <span className="text-[14px] sm:text-[15px] md:text-[17px] font-semibold tracking-tight text-[#5c5959]">
                Trusted by creators & entrepreneurs
              </span>
            </div>
          </motion.div>

          {/* ================= HERO TITLE ================= */}
          <motion.div
            className="text-center md:text-left max-w-[800px] mx-auto md:mx-0"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ ...transitionProps, delay: 0.2 }}
          >
            <h1 className="text-[#121212] font-[700]">

              {/* LINE 1 */}
              <div className="
                flex items-center justify-center md:justify-start
                gap-4 flex-wrap
                text-[40px] sm:text-[46px] md:text-[87px]
                leading-[1.05]
                tracking-[-2px] md:tracking-[-6px]
                font-semibold
              ">
                <span>We handle video</span>

              </div>

              {/* LINE 2 */}
              <div className="
                text-[40px] sm:text-[46px] md:text-[92px]
                leading-[0.5]
                mt-1 md:mt-2
                tracking-[-2px] md:tracking-[-6px]
                font-semibold
                text-center md:text-left
              ">
                <span className="text-[#3C5DF7] recoleta">editing</span>
                <span> and </span>
                <span className="text-[#3C5DF7] recoleta">logistics!</span>
              </div>
            </h1>
          </motion.div>

          {/* ================= SUBTITLE ================= */}
          <motion.p
            className="
              text-center md:text-left
              md:text-[20px]
              text-[14px]
              text-[#555]
              max-w-[500px]
              md:mt-[45px]
              mt-[30px]
              pl-[10px]
              mb-[47px]
              leading-[1.4]
              font-[600]
              mx-auto md:mx-0
            "
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ ...transitionProps, delay: 0.3 }}
          >
            We make podcasts and videos that build trust and bring back the audience every time.
          </motion.p>

          {/* ================= CTA ================= */}
          <motion.div
            className="flex justify-center md:justify-start mt-8 md:mt-10"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ ...transitionProps, delay: 0.4 }}
          >
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="
                bg-[#121212] text-white
                h-[56px] md:h-[64px]
                pl-6 pr-2
                rounded-full
                font-semibold
                text-[15px] md:text-[17px]
                flex items-center gap-4
                shadow-lg
              "
              onClick={() => navigate("/contact")}
            >
              Book a Call
              <div className="w-[40px] h-[40px] md:w-[50px] md:h-[50px] bg-white rounded-full flex items-center justify-center text-black">
                →
              </div>
            </motion.button>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;
